<template>
  <v-container class="business-addresses">
    <v-row justify="center">
      <ViewHeader :title="viewTitle">
        <div class="actions-wrapper">
          <div>
            <VideoButton
              class="ml-3 mr-8"
              @click="showVideoTutorial(viewEnum.LOCATIONS_MANAGE)"
            />
          </div>

          <div class="d-flex justify-end" v-if="showHeaderBtns">
            <ui-button
              color="primary"
              outlined
              class="min-w"
              @click="handleImportFacilities"
            >
              {{ $t("message.common.importFacilities") }}
            </ui-button>
            <v-tooltip
              max-width="500"
              bottom
              :disabled="createNewFacilityBtnVisible"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <ui-button
                    color="primary"
                    class="ml-3 min-w"
                    :disabled="!createNewFacilityBtnVisible"
                    @click="handleCreateFacility"
                  >
                    {{ $t("message.facilityCreate.title") }}
                  </ui-button>
                </div>
              </template>
              <span class="pre-line">{{
                $t("message.facilityCreate.createDisabled")
              }}</span>
            </v-tooltip>
          </div>
        </div>
      </ViewHeader>
      <v-col cols="12">
        <v-card>
          <v-tabs
            v-model="active"
            slider-color="primary"
            class="business-addresses__tabs"
          >
            <v-tab
              v-for="tab in tabsWithAccess"
              :key="tab.id"
              :to="tab.route"
              ripple
            >
              {{ $t(tab.label) }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="active" @change="updateRouter($event)">
            <v-row no-gutters justify="center">
              <v-col>
                <transition name="fade" mode="out-in">
                  <router-view class="animation-duration--500"></router-view>
                </transition>
              </v-col>
            </v-row>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ViewHeader from "@/components/ui/ViewHeader.vue";

import { mapGetters } from "vuex";
import { Permission } from "@/enums/permission";
import {
  permissionCheck,
  allFacilitiesAccessCheck
} from "@/helpers/permission-check";
import { gtmEvent__buttonClick } from "@/helpers/gtm-events";
import cuid from "cuid";
import { videoTutorialsMixin } from "@/helpers/mixins/video-tutorials";
import VideoButton from "@/components/ui/VideoButton.vue";

export default {
  name: "BusinessAddresses",
  components: {
    ViewHeader,
    VideoButton
  },
  mixins: [videoTutorialsMixin],
  data() {
    return {
      viewTitle: this.$t("message.common.businessAddresses"),
      active: 0,
      tabs: [
        {
          id: cuid(),
          label: "message.businessAddresses.list.tabTitle",
          route: { name: "business-addresses-list" },
          access: permissionCheck(Permission.VIEW_FACILITIES_DATA)
        },
        {
          id: cuid(),
          label: "message.businessAddresses.groups.tabTitle",
          route: { name: "business-addresses-groups" },
          access: allFacilitiesAccessCheck()
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      canCreateNewFacility: "company/canCreateNewFacility"
    }),
    tabsWithAccess() {
      return this.tabs.filter(tab => tab.access);
    },
    showHeaderBtns() {
      return this.active === this.$router.resolve(this.tabs[0].route).href;
    },
    createNewFacilityBtnVisible() {
      return (
        this.canCreateNewFacility &&
        permissionCheck(Permission.MANAGE_GMB_ACCOUNT)
      );
    }
  },
  methods: {
    updateRouter(val) {
      this.$router.push(val);
    },
    handleImportFacilities() {
      gtmEvent__buttonClick({ label: "import_locations" });

      this.$router.push({
        name: "profile-facility-add-new"
      });
    },
    handleCreateFacility() {
      gtmEvent__buttonClick({ label: "create_location" });

      this.$router.push({
        name: "facility-create"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.actions-wrapper {
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-content: space-between;
}
.business-addresses {
  &__tabs {
    border-bottom: 1px solid $gray-200;
    padding: 0 $spacing * 3;
  }
}

.min-w {
  min-width: 230px !important;
}
</style>
